
const validateContactList = (values) => {
    const notifications = values.notifications
    let hasSelected = false
    for (const property in notifications) {
        const val = notifications[property]
        if (val) hasSelected = true
    }

    if (!values.optIn) {
        alert('Error: You must opt in to notifications.')
        return false
    }

    if (!hasSelected) {
        alert('Error: You must select at least one alert type to be associated with this contact list.')
    }
    return hasSelected
}

export default validateContactList